import * as UserActions from './actions'

export const initialState: object = {
  id: '',
  name: '',
  role: '',
  email: '',
  avatar: '',
  authorized: false,
  loading: false,
}

export function reducer(state = initialState, action: UserActions.Actions): object {
  switch (action.type) {
    case UserActions.LOGIN:
    case UserActions.REGISTER:
    case UserActions.FORGOT_PASSWORD:
    case UserActions.SET_PASSWORD:
    case UserActions.LOAD_CURRENT_ACCOUNT:
    case UserActions.LOGOUT:
    case UserActions.LOGIN_SETTINGS:
    case UserActions.SET_IPADDRESS:
    case UserActions.VALIDATE_IPADDRESS:
      return {
        ...state,
        loading: true,
      }
    case UserActions.LOGIN_SUCCESSFUL:
    case UserActions.REGISTER_SUCCESSFUL:
    case UserActions.FORGOT_PASSWORD_SUCCESSFUL:
    case UserActions.SET_PASSWORD_SUCCESSFUL:
    case UserActions.LOAD_CURRENT_ACCOUNT_SUCCESSFUL:
    case UserActions.LOGOUT_SUCCESSFUL:
    case UserActions.LOGIN_SETTINGS_SUCCESSFUL:
    case UserActions.SET_IPADDRESS_SUCCESSFUL:
    case UserActions.VALIDATE_IPADDRESS_SUCCESSFUL:
      return {
        ...state,
        ...action.payload,
        loading: false,
        authorized: true,
      }
    case UserActions.LOGIN_UNSUCCESSFUL:
    case UserActions.REGISTER_UNSUCCESSFUL:
    case UserActions.FORGOT_PASSWORD_UNSUCCESSFUL:
    case UserActions.SET_PASSWORD_UNSUCCESSFUL:
    case UserActions.LOAD_CURRENT_ACCOUNT_UNSUCCESSFUL:
    case UserActions.LOGOUT_UNSUCCESSFUL:
    case UserActions.LOGIN_SETTINGS_UNSUCCESSFUL:
    case UserActions.SET_IPADDRESS_UNSUCCESSFUL:
    case UserActions.VALIDATE_IPADDRESS_UNSUCCESSFUL:
      return {
        ...state,
        loading: false,
        authorized: false,
      }
    case UserActions.FLUSH_USER:
      return {
        id: '',
        name: '',
        role: '',
        email: '',
        avatar: '',
        authorized: false,
        loading: false,
      }
    case UserActions.EMPTY_ACTION:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}

export const getUser = (state: any) => state
export const loadCurrentAccount = (state: any) => state
export const loginSettings = (state: any) => state
